import React from 'react';
import ReactDOM from 'react-dom';
import Search from '.';

const renderHeaderSearch = () => {
    const headerSearch = document.getElementById('header-search');

    if (!headerSearch) {
        return;
    }

    ReactDOM.render(React.createElement(Search), headerSearch);
};

renderHeaderSearch();
